(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carmona-calculator-intro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tintEmbed = () => {
    const embed = document.querySelector('shopify-forms-embed#app-embed-container-242890');
    if (!embed?.shadowRoot || embed.shadowRoot.querySelector('[data-carmona-tint]')) return;
    const style = document.createElement('style');
    style.dataset.carmonaTint = 'true';
    style.textContent = ':host{--container-background-color:#b95665!important;--button-close-background-color:#b95665!important;--forms-overlay-background-color:#403530!important}';
    embed.shadowRoot.append(style);
  };
  tintEmbed();
  const observer = new MutationObserver(tintEmbed);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 15000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carmona-catalog"] && !Shopify.designMode) return;
  try {
    
(function(){
const keys=['nutrition','species','line','prep','recipe','formats','life','size','purpose'];
function init(root){
if(root.dataset.carmonaReady)return;root.dataset.carmonaReady='true';
const cards=Array.from(root.querySelectorAll('.carmona-catalog-card'));const profiles=new Map(cards.map((c,i)=>{c.dataset.carmonaOrder=i;return[c,{...JSON.parse(c.dataset.carmonaProfile),nutrition:c.dataset.carmonaNutrition?[c.dataset.carmonaNutrition]:[]}];}));
const controls=Object.fromEntries(keys.map(k=>[k,root.querySelector('[data-carmona-filter="'+k+'"]')]));
const labels=JSON.parse(root.dataset.carmonaCategoryLabels);let category=root.dataset.carmonaDefaultCategory||'',limit=24;
function updateControls(){
let relevant=cards.filter(c=>!category||profiles.get(c).category===category);
keys.forEach(k=>{const select=controls[k],previous=select.value,vals=Array.from(new Set(relevant.flatMap(c=>profiles.get(c)[k]||[]))).sort((a,b)=>a.localeCompare(b,'it',{numeric:true}));
select.replaceChildren();const all=document.createElement('option');all.value='';all.textContent=root.dataset.carmonaAll;select.appendChild(all);
vals.forEach(v=>{const option=document.createElement('option');option.value=v;option.textContent=v;select.appendChild(option);});
select.value=vals.includes(previous)?previous:'';root.querySelector('[data-carmona-control="'+k+'"]').hidden=vals.length<2&&!select.value;if(select.value)relevant=relevant.filter(c=>(profiles.get(c)[k]||[]).includes(select.value));});
}
const categories=Array.from(new Set(cards.map(c=>profiles.get(c).category)));const nav=root.querySelector('[data-carmona-categories]');if(!categories.includes(category))category='';
if(categories.length>1){['',...categories].forEach(v=>{const button=document.createElement('button');button.type='button';button.dataset.carmonaCategory=v;button.textContent=v?(labels[v]||labels.other):root.dataset.carmonaAll;button.className='button '+(v===category?'button--primary':'button--secondary');button.setAttribute('aria-pressed',String(v===category));nav.appendChild(button);});}
const sort=root.querySelector('[data-carmona-sort]'),stock=root.querySelector('[data-carmona-stock]'),more=root.querySelector('[data-carmona-more]');
function apply(){
updateControls();
const selected=Object.fromEntries(keys.map(k=>[k,controls[k].value]));const ordered=cards.slice().sort((a,b)=>sort.value==='recommended'?Number(a.dataset.carmonaOrder)-Number(b.dataset.carmonaOrder):sort.value==='name'?a.dataset.carmonaTitle.localeCompare(b.dataset.carmonaTitle,'it'):(sort.value==='price-asc'?1:-1)*(Number(a.dataset.carmonaPrice)-Number(b.dataset.carmonaPrice))||Number(a.dataset.carmonaOrder)-Number(b.dataset.carmonaOrder));let total=0,shown=0;
ordered.forEach(card=>{const profile=profiles.get(card);const match=(!category||profile.category===category)&&(!stock.checked||card.dataset.carmonaAvailable==='true')&&keys.every(k=>!selected[k]||(profile[k]||[]).includes(selected[k]));card.hidden=!match||total>=limit;if(match){total++;if(!card.hidden)shown++;}root.querySelector('.carmona-catalog-grid').appendChild(card);
const note=card.querySelector('.carmona-catalog-match');const variants=JSON.parse(card.dataset.carmonaVariants||'[]');const recipeWords=selected.recipe?selected.recipe.toLowerCase().split(' / '):[];const hasFlavor=recipeWords.length&&variants.some(v=>recipeWords.some(w=>v.toLowerCase().includes(w)));const matches=(selected.formats||hasFlavor)?variants.filter(v=>{const units=Array.from(v.matchAll(/(\d+(?:[.,]\d+)?)\s*(chilogrammi|kilogrammi|grammi|litri|kg|ml|g|l|compresse|perle|pezzi|pz)\b/gi),x=>x[1].replace(',','.')+' '+({grammi:'g',chilogrammi:'kg',kilogrammi:'kg',litri:'l',pz:'pezzi'}[x[2].toLowerCase()]||x[2].toLowerCase()));return(!selected.formats||units.includes(selected.formats))&&(!hasFlavor||recipeWords.some(w=>v.toLowerCase().includes(w)));}):[];note.hidden=!matches.length||variants.length<2;note.textContent=matches.length?root.dataset.carmonaMatch+' '+matches.join(', '):'';});
root.querySelector('[data-carmona-status]').textContent=root.dataset.carmonaCount.replace('[shown]',shown).replace('[total]',total);root.querySelector('[data-carmona-empty]').hidden=total!==0;more.hidden=shown>=total;
}
root.addEventListener('change',e=>{if(e.target.matches('[data-carmona-filter],[data-carmona-sort],[data-carmona-stock]')){limit=24;apply();}});
root.addEventListener('click',e=>{const button=e.target.closest('[data-carmona-category],[data-carmona-reset],[data-carmona-more]');if(!button)return;if(button.hasAttribute('data-carmona-more'))limit+=24;else{limit=24;if(button.hasAttribute('data-carmona-reset')){category='';keys.forEach(k=>controls[k].value='');sort.value='recommended';stock.checked=false;}else category=button.dataset.carmonaCategory;nav.querySelectorAll('button').forEach(b=>{const active=b.dataset.carmonaCategory===category;b.setAttribute('aria-pressed',String(active));b.classList.toggle('button--primary',active);b.classList.toggle('button--secondary',!active);});}apply();});apply();
}
function scan(){document.querySelectorAll('[data-carmona-catalog]').forEach(init);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();document.addEventListener('shopify:section:load',scan);
document.addEventListener('pointerover',e=>{const details=e.target.closest('.carmona-catalog-guide details');if(details&&window.matchMedia('(hover: hover) and (pointer: fine)').matches)details.open=true;});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
